import { render, staticRenderFns } from "./EmailPlate.vue?vue&type=template&id=157e178b&scoped=true&"
import script from "./EmailPlate.vue?vue&type=script&lang=js&"
export * from "./EmailPlate.vue?vue&type=script&lang=js&"
import style0 from "./EmailPlate.vue?vue&type=style&index=0&id=157e178b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e178b",
  null
  
)

export default component.exports